/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#btn_lead_export[_ngcontent-%COMP%]{position:absolute;top:125px;right:60px}"];
export { styles as styles };
